import { camelCase, trim } from 'lodash'

import { isNonNullable } from '@subaio/utils'

import albank from './albank.json'
import coopbank from './coopbank.json'
import dab from './dab.json'
import faelleskassen from './faelleskassen.json'
import fasteroikos from './fasteroikos.json'
import fmspks from './fmspks.json'
import froerupak from './froerupak.json'
import fynskebank from './fynskebank.json'
import grbanken from './grbanken.json'
import hvidbjergbank from './hvidbjergbank.json'
import lobk from './lobk.json'
import lpb from './lpb.json'
import merkur from './merkur.json'
import moensbank from './moensbank.json'
import nordea from './nordea.json'
import nykredit from './nykredit.json'
import pensambank from './pensambank.json'
import spard from './spard.json'
import sparnord from './sparnord.json'
import vestjysk from './vestjysk.json'

type BecTheme = {
	colors: Record<string, string>
	styles: Record<string, string>
	fontFamily: string | null
}

export const formatBecTheme = (config: Record<string, string | number>): BecTheme => {
	const result = Object.entries(config).map(
		([key, value]): [key: string, { type: string; value: string }] | undefined => {
			if (typeof value === 'string') {
				const type = value.includes('#') || value.includes('rgb') ? 'color' : 'style'
				return [camelCase(key.replace('color-', '')), { type, value: trim(value) }]
			}
			return undefined
		},
	)

	return {
		colors: Object.fromEntries(
			result
				.filter(isNonNullable)
				.filter(([, { type }]) => type === 'color')
				.map(([key, { value }]) => [key, value]),
		),
		styles: Object.fromEntries(
			result
				.filter(isNonNullable)
				.filter(([, { type }]) => type === 'style')
				.map(([key, { value }]) => [key, value]),
		),
		fontFamily: (config.fontFamily as string) ?? null,
	}
}

const brandThemes = {
	albank: formatBecTheme(albank),
	coopbank: formatBecTheme(coopbank),
	dab: formatBecTheme(dab),
	faelleskassen: formatBecTheme(faelleskassen),
	fasteroikos: formatBecTheme(fasteroikos),
	fmspks: formatBecTheme(fmspks),
	froerupak: formatBecTheme(froerupak),
	fynskebank: formatBecTheme(fynskebank),
	grbanken: formatBecTheme(grbanken),
	hvidbjergbank: formatBecTheme(hvidbjergbank),
	lobk: formatBecTheme(lobk),
	lpb: formatBecTheme(lpb),
	merkur: formatBecTheme(merkur),
	moensbank: formatBecTheme(moensbank),
	nykredit: formatBecTheme(nykredit),
	pensambank: formatBecTheme(pensambank),
	spard: formatBecTheme(spard),
	sparnord: formatBecTheme(sparnord),
	vestjysk: formatBecTheme(vestjysk),

	nordea: formatBecTheme(nordea),
} as Record<string, BecTheme>

export const getBrandTheme = (brandId?: string): BecTheme => {
	if (brandId) {
		const [, bank] = brandId.split('_')
		if (brandThemes[bank]) return brandThemes[bank]
	}

	return { colors: {}, styles: {}, fontFamily: null }
}
